import useLazyQuery from "../useLazyQuery"

export const useDeletePassQuery = (passId: string) => {
	const url = `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/passes/${passId}`
	return useLazyQuery<void, void>(url, "DELETE")
}
